import { AntSelect } from 'controls/react/ant/ant-select/antSelect';
import { makeAutoObservable } from 'mobx';
import { observer } from 'mobx-react';
import { useStore } from 'core/react/useStore';
import React from 'react';
import { MobxManager } from 'framework/mobx-integration';
import { AntSelectOption, AntSelectProps, OptionExtra } from 'controls/react/ant/ant-select/types';

export type AntSelectWithCustomOptionsProps = AntSelectProps<string[]> & {};

class AntSelectWithCustomOptionsStore {
	options: AntSelectOption[];
	props: AntSelectWithCustomOptionsProps;
	initialized = false;
	mobx = new MobxManager(this);

	constructor(props: AntSelectWithCustomOptionsProps) {
		this.props = props;
		makeAutoObservable(this);
		this.options = [];
		this.mobx.reaction(
			() => this.props?.options,
			() => this.init(),
		);
	}

	onLabelEdit = (value: string, label: string) => {
		const option = this.options.find((x) => x.value == value);
		option.label = label;
		option.value = label;

		const values = this.props.value.map((x) => (x == value ? label : x));

		this.props.onChange?.(values, option);
	};

	onChange = (values: string[], option: AntSelectOption) => {
		for (const value of values) {
			const existingOption = this.options.find((x) => x.value == value);
			if (existingOption == null) {
				this.options.push({
					label: value,
					value: value,
				});
			}
		}
		this.props.onChange(values, option);
	};

	getOptionExtra = (option: AntSelectOption): OptionExtra => {
		const isTag = this.props?.options?.find((x) => x.value == option?.value) != null;

		return {
			editable: !isTag,
			removable: true,
			style: !isTag
				? {
						backgroundColor: 'var(--ant-color-info-bg)',
					}
				: null,
		};
	};

	init() {
		const customOptions = (this.props.value?.filter((x) => this.props.options.every((y) => y.value != x)) ??
			[]) as string[];
		this.options = [
			...this.props.options,
			...customOptions.map((x: string) => ({ label: x.toString(), value: x.toString() })),
		];
		this.initialized = true;
	}

	destroy: () => {};
}

export const AntSelectWithCustomOptions = observer((props: AntSelectWithCustomOptionsProps) => {
	const store = useStore(() => new AntSelectWithCustomOptionsStore(props), {
		props: props,
	});

	if (store.initialized == false) return null;

	return (
		<AntSelect
			reorderable={true}
			{...props}
			getOptionExtra={store.getOptionExtra}
			mode={'tags'}
			onLabelEdit={store.onLabelEdit}
			options={store.options}
			onChange={store.onChange}
		/>
	);
});
